import { Stack, Typography } from '@mui/material'
import { C1Icon } from 'components/core/icons/C1Icon'
import { TaskTypeComponent } from 'components/core/task/task-type'
import { CertifyTaskType, GrantTaskType, RevokeTaskType } from 'components/pages/task/type'
import { CirclePlus, KeyRound } from 'lucide-react'
import { PolicyType } from 'pbts/c1/api/policy/v1/policy'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { policyTypeIconStyles } from './styles'

export const PolicyTypeItemView = ({ type }: { type: PolicyType }): React.ReactElement => {
    switch (type) {
        case PolicyType.CERTIFY:
            return <TaskTypeComponent taskType={CertifyTaskType} />
        case PolicyType.GRANT:
            return <TaskTypeComponent taskType={GrantTaskType} />
        case PolicyType.REVOKE:
            return <TaskTypeComponent taskType={RevokeTaskType} />
        case PolicyType.ACCESS_REQUEST:
            return (
                <Stack direction="row" alignItems="center" spacing={1}>
                    <C1Icon icon={KeyRound} sx={policyTypeIconStyles.iconRequest} />
                    <Typography>
                        <FormattedMessage id="policy_type_item_request" defaultMessage="Request" />
                    </Typography>
                </Stack>
            )
        case PolicyType.PROVISION:
            return (
                <Stack direction="row" alignItems="center" spacing={1}>
                    <C1Icon icon={CirclePlus} />
                    <Typography>
                        <FormattedMessage id="policy_type_item_provision" defaultMessage="Provision" />
                    </Typography>
                </Stack>
            )
        default:
            return <FormattedMessage id="policy_type_item_default" defaultMessage="Unknown" />
    }
}
